// Temporary solution to get media fiels from Hero service
// Since images and videos from the Hero Service can't be found using our default provider,
// we need to generate the image path by combining the relative path from Hero Service with it's baseURL
//
// Note: This will be replaced by a custom Nuxt image provider in the future

import { useHeroConfig } from '#imports'

export const useHeroMedia = () => {
    const { gatewayPath } = useHeroConfig()

    const getHeroGatewayUrl = (relativeUrl: string | undefined, preset?: string | undefined) => {
        let presetPath = ''

        if (!relativeUrl) {
            return undefined
        }

        if (relativeUrl.includes('http')) return relativeUrl

        if (!gatewayPath) {
            console.warn('[getHeroGatewayUrl] Can not generate url - No gatewayPath set in hero config')

            return undefined
        }

        if (preset !== 'local') {
            presetPath = gatewayPath
        }

        return `${presetPath}${relativeUrl}`
    }

    return {
        getHeroGatewayUrl,
    }
}
